import React from 'react';
import useRole from '../../Provider/TableContext/RoleContext';
import RoleStatus from '../../Constants/RoleStatus.json';
import useCreatedRoleContext from '../../Hooks/useCreatedRoleContext';
import { useParams } from 'react-router';

const ApplyingRoleContext = React.createContext();

export function ApplyingRoleProvider(props) {
    const { roles, createRole, updateRole, loading: roleLoading } = useRole();
    const {id} = useParams();
    const role = React.useMemo(() => {
        // the role will change whenever it is updated in the backend.
        if (!roleLoading) {
            const role = {...((Array.isArray(roles) && roles.filter(role => (
                RoleStatus.Applying === (role || {}).mcb_rolestatus
                && role?.mcb_roleid === id
            ))[0]) || {})}; 
            return role;
        }
    }, [roles, roleLoading, id]);
    const { formData, setFormData, setLoading, ...contextValue} = useCreatedRoleContext({ role, updateRole, roleStatus: RoleStatus.Applying, roleStatusName: "Applying" })
    const updateApplyingRoleDetails = React.useCallback(async ()  => {
        setLoading(true);
        const role = {...(formData || {}), mcb_rolestatus: RoleStatus.Applying};
        ["mcb_atriskrenumeration", "mcb_baserenumeration"].forEach(key => {
            if (role[key] && !isNaN(role[key])) {
                role[key] = Number(role[key]);
            } else if (role[key] !== 0) {
                role[key] = null;
            }
        });
        if (!role.mcb_submitteddate) {
            role.mcb_submitteddate = null;
        }
        const result = role?.mcb_roleid? await updateRole(role): await createRole(role);
        setLoading(false);
        return result;
    }, [formData, updateRole, createRole, setLoading]);
    
    return (
        <ApplyingRoleContext.Provider value={{
            formData, setFormData, updateApplyingRoleDetails, ...contextValue
        }}>
            {props.children}
        </ApplyingRoleContext.Provider>
    );
}

export default function useApplyingRoleJourneyContext() {
    return React.useContext(ApplyingRoleContext);
}